/*
* Set up all global event handlers here
*/
import debounce from  '@js/vendor/debounce.js';
import {KEY_ESC, HTML_ELEMENT } from './globals.js';
import {toggleMenuVisibility} from './header.js';

(function() {
    window.addEventListener("keyup", function(e) {
        if (KEY_ESC.includes(e.key)) {
            handleEscapeKey();
        }
    });

    window.addEventListener("resize", debounce(function(e) {
        handlePageResize();
    }, 50));


    /*
    * Function invoked when the page is scrolled
    */
    function handlePageScroll() {

        HTML_ELEMENT.classList.toggle("state--is-scrolled", window.scrollY >= SCROLL_OFFSET);

    }

    /*
    * Function invoked when the page is resized
    */
    function handlePageResize() {
    }

    /*
    * Function invoked when the escape key is pressed
    */
    function handleEscapeKey() {
        toggleMenuVisibility(false);
    }

}());
